module.exports = __webpack_public_path__ + "img/dab_dolce.c400b365.jpg";